import React from "react";
import Menu from "../panel/Menu";

function Dashboard() {
  // Static Data
  const totalProperties = 120;
  const activeProperties = 85;
  const pendingProperties = 35;
  const totalCollection = 1250000;

  // Card style function
  const boxStyle = (bgColor) => ({
    borderRadius: 12,
    padding: "25px",
    color: "#fff",
    textAlign: "center",
    position: "relative",
    overflow: "hidden",
    boxShadow: "0 8px 20px rgba(0,0,0,0.2)",
    background: bgColor,
    transition: "transform 0.3s, box-shadow 0.3s",
    cursor: "pointer",
  });

  const iconStyle = {
    fontSize: 40,
    position: "absolute",
    top: 15,
    right: 15,
    opacity: 0.2,
  };

  return (
    <div>
      <Menu />
      <div
        className="content-wrapper"
        style={{
          backgroundColor: "#f5f5f5",
          minHeight: "100vh",
          padding: "30px 20px",
        }}
      >
        <h4 className="mb-4">🏠 Dashboard</h4>

        <div className="row">
          {/* Total Properties */}
          <div className="col-lg-3 col-6 mb-4">
            <div
              style={boxStyle("linear-gradient(135deg, #1abc9c, #16a085)")}
              className="hover-scale"
            >
              <h3>{totalProperties}</h3>
              <p>Total Properties</p>
              <i className="fas fa-building" style={iconStyle}></i>
            </div>
          </div>

          {/* Active Properties */}
          <div className="col-lg-3 col-6 mb-4">
            <div
              style={boxStyle("linear-gradient(135deg, #3498db, #2980b9)")}
              className="hover-scale"
            >
              <h3>{activeProperties}</h3>
              <p>Active Properties</p>
              <i className="fas fa-check-circle" style={iconStyle}></i>
            </div>
          </div>

          {/* Pending Properties */}
          <div className="col-lg-3 col-6 mb-4">
            <div
              style={boxStyle("linear-gradient(135deg, #e67e22, #d35400)")}
              className="hover-scale"
            >
              <h3>{pendingProperties}</h3>
              <p>Pending Properties</p>
              <i className="fas fa-hourglass-half" style={iconStyle}></i>
            </div>
          </div>

          {/* Total Collection */}
          <div className="col-lg-3 col-6 mb-4">
            <div
              style={boxStyle("linear-gradient(135deg, #9b59b6, #8e44ad)")}
              className="hover-scale"
            >
              <h3>₹{totalCollection.toLocaleString()}</h3>
              <p>Total Collection</p>
              <i className="fas fa-coins" style={iconStyle}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
